module.exports = __webpack_public_path__ + "static/media/report.93ebbed2.png";